module.exports = __webpack_public_path__ + "static/media/Haliotis_diversicolor_01.94222277.png";